import styled from 'styled-components';

export const Tooltip = styled.div`
  cursor: auto;
  position: absolute;
  top: 46%;
  transform: translateY(-10px);
  padding: 10px 15px;
  background-color: white;
  color: #4a4a4a;
  font-size: 14px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  white-space: nowrap;

  /* Triângulo inferior */
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid white;
  }

  /* Borda para o triângulo */
  &::before {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #d1d5db;
  }
`;
